export const defaultTenant = {
    tenant_id: null,
    features: {},
};

export const defaultFilter = {
    tenant_id: "", tenant_name: "", search: "", limit: 50, ordering: "-created",
};
